export default function openMap(lat, lng) {
  const parsedLat = Number(lat);
  const parsedLng = Number(lng);
  if (!Number.isFinite(parsedLat) || !Number.isFinite(parsedLng)) return false;

  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        data: { openMap: { lat: parsedLat, lng: parsedLng } },
      })
    );
    return true;
  }

  const webUrl = `https://nshn.ir/?lat=${parsedLat}&lng=${parsedLng}`;
  const isAndroid = /Android/i.test(navigator.userAgent);

  if (isAndroid) {
    window.location.href = `intent://nshn.ir/?lat=${parsedLat}&lng=${parsedLng}#Intent;scheme=https;package=org.rajman.neshan.traffic.tehran.navigator;S.browser_fallback_url=${encodeURIComponent(
      webUrl
    )};end`;
    return true;
  }

  window.open(webUrl, '_blank');
  return true;
}
